/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { FrotasService } from "../shared/frota.service";
import { FrotaNavigationService } from "../shared/frota-navigation.service";
import { FrotaApiService } from "../shared/frota-api.service";
import { AttService } from "../../../shared/services/att.service";
import {UtilService} from "../../../shared/services/util.service";

@Component({
    template: require('./frota-imagem.component.html'),
    styles: [require('./frota-imagem.component.css')]
})
export class FrotaImagemComponent implements OnInit {
    frotasModule: any = {};
    thisRoute:string = '';
    detail: any = {};
    images: any[] = [];
    loading: boolean = true;
    showView: boolean = false;

    private moduleId: number;
    private files: number;
    private files2: number;
    private imagesToSave: any[] = [];

    constructor(
        private _frotaService: FrotasService,
        private _frotaNavigationService: FrotaNavigationService,
        private _frotaApiService: FrotaApiService,
        private _attService: AttService,
        private _utilService: UtilService,
        private _route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.frotasModule = this._frotaService.getModuleName();
        this.thisRoute = this._frotaService.getRouteName();
        this.moduleId = this._frotaService.getModuleId();

        let id = +this._route.snapshot.params['id'];
        this.getObject(id);
        this.getImages(id);
    }

    clickGoToList() {
        this._frotaNavigationService.goToList(this.thisRoute);
    }

    clickGoToDetail() {
        this._frotaNavigationService.goToDetail(this.detail.id, this.thisRoute);
    }

    changeFile(e: any) {
        this.loading = true;
        let target = e.target;

        let isValid = this._attService.isValidAttachment(target, true, false);
        if (isValid) {
            let x: number, lenX: number;
            this.files = target.files.length;
            this.files2 = 0;
            this.imagesToSave = [];

            for (x = 0, lenX = target.files.length; x < lenX; x++) {
                this.sendAttachment(target.files[x]);
            }
        }
    }

    clickDelete(item: any) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    clickViewImage(item: any, index: number) {
        // this.showView = true;

    }

    private getObject(id: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                const storage = this._frotaService.getSessionStorage();
                if (storage) {
                    Response.Combustiveis = storage.Combustiveis;
                }
                this.detail = Response;
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum ' + this.frotasModule.single + ' encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._frotaApiService.onGetById(id, onDone);
    }

    private getImages(id: number) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.images = Response;
                this.loading = false;
            }
        }.bind(this));

        this._frotaApiService.onGetAllImagem(id, onDone);
    }

    private sendAttachment(item: any) {
        this._attService.loadFile(item, this.responseSuccessS3File);
    }

    private responseSuccessS3File = (function(response: any) {
        this.saveFile(response);
    }.bind(this));

    private saveFile(response: any) {
        let description = this.detail.identificacao;
        if (this.detail.placa) {
            let placa:any = this.detail.placa.toUpperCase();
            placa = placa.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
            description = description.concat(" - Placa: " + placa);
        }

        if (this.detail.codigo) {
            description = description.concat(" - Registro: " + this.detail.codigo);
        }

        let newAtt: any = {
            descricao: description,
            url: response.url,
            formato: response.fileExtension,
            data: new Date(),
            ativo: true,
            bemId: this.detail.id
        };

        this.imagesToSave.push(newAtt);
        this.files2 += 1;
        if (this.files === this.files2) {
            this.onSave();
        }
    }

    private onSave() {
        let onDone = (function(Response: any) {
            this.getImages(this.detail.id);
            this.loading = false;
        }.bind(this));

        let images: any = {Imagens: this.imagesToSave};
        this._frotaApiService.onPostImages(images, onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.images.length; x < lenX; x++) {
                    if (this.images[x].id === item.id) {
                        this.images.splice(x, 1);
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._frotaApiService.onDeleteImagem(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/frota-imagem/frota-imagem.component.ts
 **/